class CartNotification {
  constructor() {
    this.el = document.querySelector('[data-cart-notification]')
    this.productEl = document.querySelector('[data-notification-product]')
    this.close = document.querySelector('[data-notification-close]')
    this.cartItemCounts = document.querySelectorAll('#cart-item-count')
  }

  init() {
    document.addEventListener('cart-add', e => this.cartAddListener(e.detail))
    document.addEventListener('cart-error', e => this.cartErrorListener(e.detail))
    this.close.addEventListener('click', () => this.closeNotification())

    window.addEventListener('click', e => {
      if(e.target.closest('[data-cart-notification]')) return
      this.closeNotification()
    })
  }

  async cartAddListener(product) {
    console.log(product)
    const { image, title, options_with_values, price } = product

    const res = await fetch('/cart.js')
    const json = await res.json()
    console.log(json)
    this.cartItemCounts.forEach(el => el.innerHTML = json.item_count)

    let size, color;
    if(options_with_values) {
      options_with_values.forEach(option => {
        if(option.name === 'Size') size = option.value
        if(option.name === 'Color') color = option.value
      })
    }

    const raw = `
      <div class="notf-product">
        <div class="notf-product__image">
          <img src="${image}" />
        </div>
        <div class="notf-product__info">
          <h5 class="notf-product__info-title">${title}</h5>
          <span class="notf-product__info-color">${color ? color : ""}</span>
          <span class="notf-product__info-size">${size ? size : ""}</span>
          <span class="notf-product__info-price">${(price / 100).toLocaleString("en-US", {
            style: "currency",
            currency: "USD"
          })}</span>
        </div>
      </div>
    `

    this.productEl.innerHTML = raw
    this.el.classList.add('show')
    setTimeout(() => {
      this.closeNotification()
    }, 3000)
  } 

  cartErrorListener(err) {
    this.el.querySelectorAll('*:not([data-notification-product])').forEach(el => el.style.display = 'none')
    this.productEl.innerHTML = `<span style="color: crimson">ERROR:</span> ${err}`
    
    this.el.classList.add('show')

    setTimeout(() => {
      this.closeNotification()
      this.el.querySelectorAll('*:not([data-notification-product])').forEach(el => el.removeAttribute('style'))
    }, 3000)
  }

  closeNotification() {
    this.el.classList.remove('show')
    setTimeout(() => {
      this.productEl.innerHTML = ""
    }, 250)
  }
}
